// Autogenerated file
export const invoiceTriggerTypesEnum = {
    ByOriginal: "ByOriginal",
    ByScan: "ByScan",
    AtUnloading: "AtUnloading",
};
export const invoiceTriggerTypes = [
    { label: "По оригиналам", value: "ByOriginal" },
    { label: "По сканам", value: "ByScan" },
    { label: "При выгрузке", value: "AtUnloading" },
];
